<template>
    <span v-html="imgSvg"></span>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'ImportJs',
    props: ['src'],
    data() {
        return {
            imgSvg: ''
        }
    },
    mounted() {
        this.imgSvg = this.src
        if (this.src) {
            axios.get(this.src).then(val => this.imgSvg = val.data)
        }
    }
})
</script>